import type { OmnisyniaClientModule } from "./module.types";
import { accountClientModule } from "./account/account.module";
import { chatOmnisyniaClientModule } from "./chat-omnisynia/chat-omnisynia.module";
import { socialCutProClientModule } from "./socialcut-pro/socialcut-pro.module";
import { ultraClientModule } from "./ultra/ultra.module";

const registeredModules = [
  chatOmnisyniaClientModule,
  accountClientModule,
  ultraClientModule,
  socialCutProClientModule
] as const;

export const moduleRegistry: readonly OmnisyniaClientModule[] = Object.freeze(
  registeredModules
);

export function getClientModule(moduleId: string): OmnisyniaClientModule | undefined {
  return moduleRegistry.find((module) => module.id === moduleId);
}
